export default function HomeStatsBar() {
  // Stats are now shown in the Hero bottom strip — this component is intentionally minimal
  return null;
}
